// A mock function to mimic making an async request for data
import axios from "axios";
export function fetchEventConfig() {
  console.log("process.env.API_DOMAIN" + process.env.REACT_APP_API_DOMAIN);
  return axios.get(`${process.env.REACT_APP_API_DOMAIN}/api/event/`);
}
